<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Delivery Order Details">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-po-number" label-cols-lg="12" label="PO Number" label-for="input-po-number" size="sm" :model.sync="model.poNumber"  />
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="input-" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
				<app-input-textbox id="fieldset-qty-per-unit" label-cols-lg="12" label="QtyPerUnit" label-for="input-qty-per-unit" size="sm" :model.sync="model.qtyPerUnit"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-datepicker id="fieldset-delivery-date" label-cols-lg="12" label="Delivery Date" size="sm" :model.sync="model.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" />
				<app-input-combobox-autocomplete :options="deliveryStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Delivery Status" id="input-" size="sm" :model.sync="model.deliveryStatusId"   :selected="model.deliveryStatus != null ? model.deliveryStatus.name : ''" @input="getDeliveryStatuss" />
				<app-input-combobox-autocomplete :options="doProgressStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="DO Progress Status" id="input-" size="sm" :model.sync="model.doProgressStatusId"   :selected="model.doProgressStatus != null ? model.doProgressStatus.name : ''" @input="getDoProgressStatuss" />
					</b-col>
					<b-col cols="12" lg="6">

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import DeliveryOrderDetail from '@/models/DeliveryOrder/DeliveryOrderDetail';
import DeliveryOrderDetailFilter from '@/filters/DeliveryOrder/DeliveryOrderDetailFilter';

import DeliveryOrder from '@/models/DeliveryOrder/DeliveryOrder';
import DeliveryOrderFilter from '@/filters/DeliveryOrder/DeliveryOrderFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import PurchaseOrderDetail from '@/models/PurchaseOrder/PurchaseOrderDetail';
import PurchaseOrderDetailFilter from '@/filters/PurchaseOrder/PurchaseOrderDetailFilter';
import DeliveryStatus from '@/models/DeliveryStatus/DeliveryStatus';
import DeliveryStatusFilter from '@/filters/DeliveryStatus/DeliveryStatusFilter';
import DoProgressStatus from '@/models/DoProgressStatus/DoProgressStatus';
import DoProgressStatusFilter from '@/filters/DoProgressStatus/DoProgressStatusFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			parts : [],
			purchaseOrderDetails : [],
			deliveryStatuss : [],
			doProgressStatuss : [],
			isBusy: false,
		}
	},
	methods : {
		getDeliveryOrderDetail : async function(id) {
			this.isBusy = true;
			DeliveryOrderDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getPurchaseOrderDetails : async function(input) {
			let filter = new PurchaseOrderDetailFilter();
			if (input != undefined) {
				filter.qtyPo = input;
			}
			PurchaseOrderDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.purchaseOrderDetails = result.data
				}
			})
			.catch(error => {});
		},
		getDeliveryStatuss : async function(input) {
			let filter = new DeliveryStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DeliveryStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getDoProgressStatuss : async function(input) {
			let filter = new DoProgressStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DoProgressStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.doProgressStatuss = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getParts();
		//this.getPurchaseOrderDetails();
		//this.getDeliveryStatuss();
		//this.getDoProgressStatuss();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getDeliveryOrderDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getParts();
				this.getPurchaseOrderDetails();
				this.getDeliveryStatuss();
				this.getDoProgressStatuss();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getDeliveryOrderDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
